export const pageRoutes = {
  home: "home",
  assistant: "assistant",
  investorRelations: "investor",
  contacts: "contacts",
  investors: "investors",
  investorPortalSettings: "settings",
  userConsents: "user-consents",
  documentCollections: "document-collections",
  documentActivity: "document-activity",
  fundraisings: "fundraisings",
  messages: "messages",
  documents: "documents",
  activity: "activity",
  investorEmails: "emails",
  accessCategories: "access-categories",
  investorCommunications: "investor-communications",
  portfolioEmails: "portfolio-emails",
  companyReports: "reports",
  companyReportConfiguration: "configuration",
  reportTemplates: "templates",
  reports: "reports",
  reportLevels: "report-levels",
  settings: "settings",
  settingsCompanyGeneral: "company-general",
  settingsOrganizationContacts: "organization-contacts",
  settingsMembers: "members",
  settingsUserGroups: "user-groups",
  settingsIntegrations: "integrations",
  settingsActivityLog: "activity-log",
  integration: "integration",
  apiGateway: "api-gateway",
  dataBackup: "data-backup",
  entriliaMcp: "entrilia-mcp",
  passthrough: "passthrough",
  snowflake: "snowflake",
  salesforce: "salesforce",
  dealcloud: "dealcloud",
  agenticWorkflows: "agentic-workflows",
  organizationReports: "organization-reports",
  funds: "funds",
  files: "files",
  expenseManagement: "expenses",
  invoices: "invoices",
  vendors: "vendors",
  portfolio: "portfolio",
  fundInvestments: "fund-investments",
  portfolioCompanies: "portfolio-companies",
  dataRequestSetup: "data-request-setup",
  dataRequestTemplates: "data-request-templates",
  dataRequests: "data-requests",
  dataSubmissions: "data-submissions",
  metrics: "metrics",
  scenarios: "scenarios",
  portfolioPortal: "portfolio-portal",
  importData: "import-data",
  importCsvData: "csv-import",
  importDetails: "details",
  importReview: "review",
  requests: "requests",
  dashboardWidgetSettings: "dashboard-widget-settings",
  portfolioWidgetSettings: "portfolio-widget-settings",
  workflows: "workflows",
  approvals: "approvals",
  approvalObject: "approval-object",
  changeRequest: "change-request",
  dataModel: "data-model",
  orgObjects: "org-objects",
  layout: "layout",
  checklists: "checklists",
  records: "records",
  smartViews: "smart-views",
  aiDashboards: "ai-dashboards",
  apiReports: "api-reports",
  systemReports: "system-reports",
  agentInboxes: "agent-inboxes",
  dashboards: "dashboards",
  organizationApiReports: "organization-api-reports",
  bcRedirect: "bc-redirect",
  fundOpsTransactionLink: "fund-ops-transaction-link",
  videoLibrary: "video-library",
  workflowRuns: "workflow-runs",
  workflowTemplates: "workflow-templates",
  workflowChecklists: "workflow-checklists",
  taskTemplates: "task-templates",
  workflowActivity: "workflow-activity",
  fields: "fields",
  workbookRunner: "workbook-runner",
  standardReports: "standard-reports",
  balanceSheet: "balance-sheet",
  incomeStatement: "income-statement",
  apAgingSummary: "ap-aging-summary",
  arAgingSummary: "ar-aging-summary",
  apAgingDetail: "ap-aging-detail",
  arAgingDetail: "ar-aging-detail",
  accountSettings: "account-settings",
  aboutInvestorPortal: "about-investor-portal",
};
